<template>
  <div class="policy-page">
    <!-- 头部标题 -->
    <div class="header">
      <div class="center nav">
        <span>政策需求中心</span>
        <strong @click="logoutPolicy">退出</strong>
      </div>
    </div>
    <!-- 搜索form -->
    <div class="search center">
      <el-form :inline="true" :model="policySearchKeys" class="demo-form-inline">
        <el-form-item label="政策名称：">
          <el-input v-model="policySearchKeys.policyName" placeholder="请输入关键词"></el-input>
        </el-form-item>
        <el-form-item label="地区：">
          <el-select v-model="policySearchKeys.policyProvince" placeholder="不限">
            <el-option label="全国" value></el-option>
            <!-- value=""  ctrl+s自动保存后，它变为value,下面还有几处 也不能写为 value=" "-->
            <el-option label="中央" value="中央"></el-option>
            <el-option label="北京市" value="北京市"></el-option>
            <el-option label="天津市" value="天津市"></el-option>
            <el-option label="河北省" value="河北省"></el-option>
            <el-option label="山西省" value="山西省"></el-option>
            <el-option label="内蒙古" value="内蒙古"></el-option>
            <el-option label="辽宁省" value="辽宁省"></el-option>
            <el-option label="吉林省" value="吉林省"></el-option>
            <el-option label="黑龙江省" value="黑龙江省"></el-option>
            <el-option label="上海市" value="上海市"></el-option>
            <el-option label="江苏省" value="江苏省"></el-option>
            <el-option label="浙江省" value="浙江省"></el-option>
            <el-option label="安徽省" value="安徽省"></el-option>
            <el-option label="福建省" value="福建省"></el-option>
            <el-option label="江西省" value="江西省"></el-option>
            <el-option label="山东省" value="山东省"></el-option>
            <el-option label="河南省" value="河南省"></el-option>
            <el-option label="湖北省" value="湖北省"></el-option>
            <el-option label="湖南省" value="湖南省"></el-option>
            <el-option label="广东省" value="广东省"></el-option>
            <el-option label="广西" value="广西"></el-option>
            <el-option label="海南省" value="海南省"></el-option>
            <el-option label="重庆市" value="重庆市"></el-option>
            <el-option label="四川省" value="四川省"></el-option>
            <el-option label="贵州省" value="贵州省"></el-option>
            <el-option label="云南省" value="云南省"></el-option>
            <el-option label="西藏自治区" value="西藏自治区"></el-option>
            <el-option label="陕西省" value="陕西省"></el-option>
            <el-option label="甘肃省" value="甘肃省"></el-option>
            <el-option label="青海省" value="青海省"></el-option>
            <el-option label="宁夏" value="宁夏"></el-option>
            <el-option label="新疆维吾尔自治区" value="新疆维吾尔自治区"></el-option>
            <el-option label="台湾省" value="台湾省"></el-option>
            <el-option label="香港特别行政区" value="香港特别行政区"></el-option>
            <el-option label="澳门特别行政区" value="澳门特别行政区"></el-option>
            <el-option label="海外" value="海外"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="政策类型：">
          <!--更合适的是:policyTypeName -->
          <el-select v-model="policySearchKeys.policyType" placeholder="不限">
            <el-option label="不限" value></el-option>
            <el-option label="行政措施" value="zdfc"></el-option>
            <el-option label="金融贷款" value="jrdk"></el-option>
            <el-option label="税收优惠" value="ssjm"></el-option>
            <el-option label="租金减免" value="fzbt"></el-option>
            <el-option label="人力资源" value="rlzy"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="客户意向：">
          <el-select v-model="policySearchKeys.customerIntention" placeholder="全部">
            <el-option label="全部" value></el-option>
            <el-option label="有意向" value="yyx"></el-option>
            <el-option label="无意向" value="wyx"></el-option>
            <el-option label="待跟进" value="dgj"></el-option>
          </el-select>
        </el-form-item>
        <span class="datelabel">申请日期：</span>
        <el-date-picker
          v-model="chooseDate"
          clearable
          type="daterange"
          align="right"
          range-separator="~"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          :picker-options="pickerOptions"
          format="yyyy-MM--dd"
          value-format="yyyy-MM-dd"
        ></el-date-picker>
        <el-button type="primary" @click="onSubmit">查询</el-button>
      </el-form>
    </div>
    <!-- 数据展示table -->
    <div class="showdata center">
      <div class="lists center">
        <el-table :data="policyData" v-loading="loading">
          <el-table-column prop="policyNo" label="政策编号" align="center" width="100">
            <template slot-scope="scope">
              <span>{{ scope.row.policyNo ? scope.row.policyNo : "---" }}</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="policyName"
            label="政策名称"
            align="center"
            min-width="150"
            :show-overflow-tooltip="true"
          >
            <template slot-scope="scope">
              <span>{{ scope.row.policyName ? "《"+scope.row.policyName+"》" : "---" }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="policyProvince" label="地区" align="center" width="100">
            <template slot-scope="scope">
              <span>{{ scope.row.policyProvince ? scope.row.policyProvince : "---" }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="policyType" label="政策类型" align="center" width="90">
            <template slot-scope="scope">
              <span>{{ scope.row.policyType ? scope.row.policyType=='zdfc'?'行政措施': scope.row.policyType=='fzbz'?'租金减免': scope.row.policyType=='jrdk'?'金融贷款':scope.row.policyType=='ssjm'?'税收优惠':scope.row.policyType=='rlzy'?'人力资源':"":"---" }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="contacts" label="客户姓名" align="center" width="90">
            <template slot-scope="scope">
              <span>{{ scope.row.contacts ? scope.row.contacts : "---" }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="mobile" label="客户电话" align="center" width="130">
            <template slot-scope="scope">
              <span>{{ scope.row.mobile ? scope.row.mobile : "---" }}</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="company"
            label="公司名称"
            align="center"
            min-width="100"
            :show-overflow-tooltip="true"
          >
            <template slot-scope="scope">
              <span>{{ scope.row.company ? scope.row.company : "---" }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="industry" label="所属行业" align="center" width="100">
            <template slot-scope="scope">
              <span>{{ scope.row.industry ? scope.row.industry : "---" }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="customerIntention" label="客户意向" align="center" width="90">
            <template slot-scope="scope">
              <span>{{ scope.row.customerIntention ? scope.row.customerIntention=='yyx'?"有意向": scope.row.customerIntention=='wyx'?"无意向":scope.row.customerIntention=='dgj'?"待跟进": "":"---" }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="applyDate" label="申请日期" align="center" width="105">
            <template slot-scope="scope">
              <span>{{ scope.row.applyDate ? scope.row.applyDate.split("T")[0]:"---" }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="note" label="操作" align="center">
            <template slot-scope="scope">
              <el-button type="text" @click="noteBtnClick(scope.row)">备注</el-button>
            </template>
          </el-table-column>
        </el-table>
        <!-- 点击表格里面的备注弹出 对话框 -->
        <el-dialog title="备注" :visible.sync="dialogFormVisible">
          <el-tabs v-model="activeName" type="border-card" stretch @tab-click="handleClick">
            <el-tab-pane label="添加备注" name="addnote">
              <el-form ref="addnoteform" :model="addnoteform" label-width="80px">
                <el-form-item label="客户意向:">
                  <el-select v-model="addnoteform.intention" placeholder="全部">
                    <el-option label="有意向" value="yyx"></el-option>
                    <el-option label="无意向" value="wyx"></el-option>
                    <el-option label="待跟进" value="dgj"></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="备注内容:">
                  <el-input type="textarea" v-model="addnoteform.notedesc"></el-input>
                </el-form-item>
              </el-form>
            </el-tab-pane>
            <el-tab-pane label="备注记录" name="noterecord">
              <el-table :data="notecordtable" max-height="200">
                <el-table-column type="index" width="50" label="序号" align="center"></el-table-column>
                <el-table-column prop="customerIntention" label="客户意向" align="center">
                  <template slot-scope="scope">
                    <span>{{ scope.row.customerIntention ? scope.row.customerIntention=='yyx'?"有意向": scope.row.customerIntention=='wyx'?"无意向":scope.row.customerIntention=='dgj'?"待跟进": "":"---" }}</span>
                  </template>
                </el-table-column>
                <el-table-column
                  prop="intentionContent"
                  label="备注内容"
                  align="center"
                  :show-overflow-tooltip="true"
                ></el-table-column>
                <el-table-column prop="submitDate" label="备注时间" align="center">
                  <template slot-scope="scope">
                    <span>{{ scope.row.submitDate ? scope.row.submitDate.split("T")[0]:"---" }}</span>
                  </template>
                </el-table-column>
              </el-table>
            </el-tab-pane>
          </el-tabs>
          <div slot="footer" class="dialog-footer">
            <el-button @click="handleCancelDialog">取 消</el-button>
            <el-button type="primary" @click="handleConform">确 定</el-button>
          </div>
        </el-dialog>
      </div>

      <div class="pagination">
        <el-pagination
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-size="20"
          layout="total, prev, pager, next"
          :total="this.allCount"
        ></el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import { logout } from "@/api/user.js";
import { removeCookie, getCookie } from "@/utils/getToken.js";
import { getPolicyNeedList, submitPolicyNeedNotes } from "@/api/policy.js";
export default {
  data() {
    return {
      // 带快捷选项的日期范围选择
      pickerOptions: {
        shortcuts: [
          {
            text: "最近一周",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: "最近一个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: "最近三个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit("pick", [start, end]);
            }
          }
        ]
      },
      // 默认选中对话框中面板的名字
      activeName: "addnote",
      //提交备注的请求接口参数
      subNoteParams: {
        needId: null, //needId为 "",res.data
        customerIntention: "",
        intentionContent: ""
      },
      // 点击index的Tab项
      indexTab: 0,
      // 是否显示对话框
      dialogFormVisible: false,
      // 添加备注表格的接口参数
      addnoteform: {
        intention: "",
        notedesc: ""
      },
      // 备注记录
      notecordtable: [],
      // 政策查询参数
      policySearchKeys: {
        policyName: "",
        policyProvince: "",
        policyType: "",
        customerIntention: ""
      },
      // 日期选择器
      chooseDate: "",

      // 表单数据
      policyData: [],
      currentPage: 1,
      // loading动画
      loading: false,

      // 总的数据条数
      allCount: null
    };
  },
  created() {
    this.loading = true;
    let params = {
      policyName: "",
      policyProvince: "",
      policyCity: "",
      policyType: "",
      customerIntention: "",
      pageSize: "20",
      pageIndex: "",
      startDate: "",
      endDate: ""
    };
    this.initQueryPolicy(params);
  },
  methods: {
    // 点击取消对话框
    handleCancelDialog() {
      this.dialogFormVisible = false;
      this.notecordtable = [];
    },

    // 提取出来的初始查询政策方法 --- 调用多次
    initQueryPolicy(params) {
      return getPolicyNeedList(params).then(res => {
        // console.log("查询的参数:", params, "\n查询的全部数据:\n", res);
        if (res.status == 0) {
          if (res.data == null) {
            this.$message({
              message: "数据为空，请刷新重试",
              type: "warning"
            });
          } else {
            this.policyData = res.data;
            this.allCount = ~~res.dataCount;
            this.loading = false;
          }
        } else if ((res.status = -99)) {
          this.$message({
            message: "请重新登录",
            type: "warning"
          }),
            this.$router.push("/user");
        }
      });
    },

    // 退出政策登录
    logoutPolicy() {
      let userpin = getCookie("userpin");
      // console.log(userpin);
      logout(userpin).then(res => {
        // console.log(res);
        if (res.status == 0) {
          removeCookie("userpin");
          removeCookie("username");
          this.$message({
            message: "已退出登录！",
            type: "success"
          });
          this.$router.push("/user");
        } else if ((res.status = -99)) {
          // console.log("-99", res);
          this.$message({
            message: "登录已经失效",
            type: "warning"
          }),
            this.$router.push("/user");
        } else {
          // console.log("退出登录失败", res);
          this.$message.error("退出登录失败！");
        }
      });
    },

    // 对话框里的Tab切换时
    handleClick(tab, event) {
      this.indexTab = tab.index;
      if (tab.index == 0) {
        // 清除掉备注表格里面的内容
        this.addnoteform.intention = "";
        this.addnoteform.notedesc = "";
      }
    },
    // 点击Tab栏的对应的确认按钮
    handleConform() {
      // 当添加备注的时候点击确定提交数据
      if (this.indexTab == 0) {
        this.subNoteParams.customerIntention = this.addnoteform.intention;
        this.subNoteParams.intentionContent = this.addnoteform.notedesc;
        // console.log("备注提交接口的参数：", this.subNoteParams);
        //  进行备注提交
        submitPolicyNeedNotes(this.subNoteParams).then(res => {
          // console.log(res);
          if (res.status == 0) {
            // 提交成功的话，把客户意向更新
            this.policyData.customerIntention = this.subNoteParams.customerIntention;
            // 重新请求数据，获取新的opNotes
            let params = {
              policyName: this.policySearchKeys.policyName,
              policyProvince: this.policySearchKeys.policyProvince,
              policyCity: "",
              policyType: this.policySearchKeys.policyType,
              customerIntention: this.policySearchKeys.customerIntention,
              pageSize: "20",
              pageIndex: "",
              startDate:
                this.chooseDate == ""
                  ? ""
                  : this.chooseDate == null
                  ? ""
                  : this.chooseDate[0],
              endDate:
                this.chooseDate == ""
                  ? ""
                  : this.chooseDate == null
                  ? ""
                  : this.chooseDate[1]
            };
            this.initQueryPolicy(params);
          } else {
            // console.log("提交备注失败", res);
            this.$message({
              type: "warning",
              message: res.msg
            });
          }
        });
      }

      this.dialogFormVisible = false;
      this.notecordtable = []; //得清空备注数组，否则会不同行的备注内容串行
    },

    // 点击备注按钮
    noteBtnClick(row) {
      // console.log("点击备注按钮得到的那一行数据：", row);
      this.subNoteParams.needId = row.id; // 把row里面的 id 作为needId
      if (row.opNotes == null) {
        // 表格数据的装填 [] = null
      } else {
        this.notecordtable = JSON.parse(row.opNotes).data;
      }

      // 把对话框的面板默认显示添加备注页面
      this.activeName = "addnote";
      this.dialogFormVisible = true;
      // 清除掉备注表格里面的内容
      this.addnoteform.intention = "";
      this.addnoteform.notedesc = "";
    },
    // 点击查询，提交查询参数
    onSubmit() {
      // console.log("submit!", this.chooseDate == "", this.chooseDate == null); // 刚开始为 "" 当选完日期控件之后点击清除图标则是null
      // 提交查询的字段
      let params = {
        policyName: this.policySearchKeys.policyName,
        policyProvince: this.policySearchKeys.policyProvince,
        policyCity: "",
        policyType: this.policySearchKeys.policyType,
        customerIntention: this.policySearchKeys.customerIntention,
        pageSize: "20",
        pageIndex: "",
        startDate:
          this.chooseDate == ""
            ? ""
            : this.chooseDate == null
            ? ""
            : this.chooseDate[0],
        endDate:
          this.chooseDate == ""
            ? ""
            : this.chooseDate == null
            ? ""
            : this.chooseDate[1]
      };
      // console.log("点击按钮提交查询参数", params);
      this.loading = true;
      // 分页器的总数，数据总数和查询筛出来的数据总数不同
      getPolicyNeedList(params).then(res => {
        // console.log("查询的参数:", params, "\n查询的全部数据:\n", res);
        if (res.status == 0) {
          this.policyData = res.data;
          // 查询之后总数 dataCount
          this.allCount = ~~res.dataCount;
          this.loading = false;
        } else if ((res.status = -99)) {
          this.$message({
            message: "请重新登录",
            type: "warning"
          }),
            this.$router.push("/user");
        }
      });
    },

    // 分页器
    handleCurrentChange(val) {
      // console.log(`当前页: ${val}`);
      // 再次请求数据
      this.loading = true;
      // 提交查询的字段
      let params = {
        policyName: this.policySearchKeys.policyName,
        policyProvince: this.policySearchKeys.policyProvince,
        policyCity: "",
        policyType: this.policySearchKeys.policyType,
        customerIntention: this.policySearchKeys.customerIntention,
        pageSize: "20",
        pageIndex: val,
        startDate:
          this.chooseDate == ""
            ? ""
            : this.chooseDate == null
            ? ""
            : this.chooseDate[0],
        endDate:
          this.chooseDate == ""
            ? ""
            : this.chooseDate == null
            ? ""
            : this.chooseDate[1]
      };
      this.initQueryPolicy(params);
      // 改变页码的高亮
      this.currentPage = ~~val;
    }
  }
};
</script>

<style lang="scss" >
.policy-page {
  min-height: 100%;
  .center {
    width: 1200px;
    margin: 0 auto;
  }
  .header {
    height: 60px;
    width: 100%;
    line-height: 60px;
    background: #000;
    color: #fff;
    font-size: 18px;
    .nav {
      display: flex;
      justify-content: space-between;
      span {
        padding-right: 30px;
      }
      strong {
        cursor: pointer;
      }
    }
  }
  .search {
    background: rgba(247, 248, 252, 1);
    margin-bottom: 10px;
    padding-top: 20px;
    display: flex;
    align-items: center;
    justify-content: center;
    .el-form {
      .el-form-item {
        .el-form-item__label {
          padding-right: 0px;
        }
        .el-form-item__content {
          width: 120px;
        }
      }
      .selfwidth {
        width: 80px;
      }
      .datelabel {
        color: #606266;
      }
      .el-date-editor {
        width: 260px;
        height: 40px;
        margin-right: 10px;
      }
    }
  }
  .showdata {
    min-height: 620px;
    display: flex;
    flex-direction: column;
    border: 1px solid #ddd;
    .lists {
      flex: 1;
      .el-table {
        width: 1198px;
        /*  */
        font-family: PingFangSC-Regular;
        font-size: 14px;
        color: #333333;
        .el-table__header-wrapper .el-table__header .has-gutter tr th {
          background: rgba(247, 248, 252, 1);
        }
        .el-table__body-wrapper {
          .el-table__row {
            td {
              height: 20px;
              padding-bottom: 0;
              padding-top: 0;
            }
          }
        }
      }
    }
    .pagination {
      width: 1198px;
      height: 60px;
      background: rgba(247, 248, 252, 1);
      margin: 0 auto;
      text-align: right;
      .el-pagination {
        margin: 15px 0;
      }
    }
  }
}
</style>